module.exports = __webpack_public_path__ + "img/route_country.5c4a7ba.png";